import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Was ist die THG-Quote?',
      answer: 'Die Treibhausgasminderungsquote (THG-Quote) ist ein gesetzliches Instrument zur Reduktion von CO₂-Emissionen im Verkehrssektor. Halter von Elektrofahrzeugen können ihre eingesparten CO₂-Emissionen zertifizieren lassen und verkaufen.'
    },
    {
      question: 'Wer kann die THG-Prämie beantragen?',
      answer: 'Alle Halter von rein elektrischen Fahrzeugen (BEV) sind berechtigt. Hybridfahrzeuge sind nicht förderfähig.'
    },
    {
      question: 'Wie funktioniert die Abwicklung?',
      answer: 'Sie wenden sich an eines unserer Partnerautohäuser, übermitteln Ihre Fahrzeugdaten und den Fahrzeugschein. Grid Balance kümmert sich um die komplette Abwicklung beim Umweltbundesamt.'
    },
    {
      question: 'Wie lange dauert die Bearbeitung?',
      answer: 'Die Prüfung und Abwicklung dauert in der Regel 2–4 Monate, abhängig von der Bearbeitungszeit des Umweltbundesamtes.'
    },
    {
      question: 'Ist die Teilnahme kostenlos?',
      answer: 'Ja, die Abwicklung über Grid Balance ist für Sie kostenlos. Es gibt keine versteckten Gebühren.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 md:py-16 bg-muted/30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-4">
            Häufig gestellte Fragen
          </h2>
          <p className="text-muted-foreground">
            Hier finden Sie Antworten auf die wichtigsten Fragen zur THG-Prämie
          </p>
        </div>

        <div className="space-y-4">
          {faqs?.map((faq, index) => (
            <div
              key={index}
              className="bg-card rounded-lg shadow-card overflow-hidden transition-smooth"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-muted/50 transition-smooth"
              >
                <span className="font-heading font-semibold text-foreground pr-4">
                  {faq?.question}
                </span>
                <Icon
                  name={openIndex === index ? 'ChevronUp' : 'ChevronDown'}
                  size={20}
                  color="var(--color-primary)"
                  className="flex-shrink-0"
                />
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-6 text-muted-foreground animate-fade-in">
                  {faq?.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;